import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import { useTranslation } from 'react-i18next';

type PreviewCloseButtonProps = {
  onClose: () => void;
  width: number;
  height: number;
};

export const PreviewCloseButton = ({ onClose, width, height }: PreviewCloseButtonProps) => {
  const { t } = useTranslation();

  return (
    <IconButton
      aria-label={t('Close creative preview')}
      onClick={onClose}
      sx={theme => ({
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: `translate(calc(-50% + ${width / 2}px + 8px), calc(-50% - ${height / 2}px - 8px))`,
        zIndex: theme.zIndex.modal + 2,
        backgroundColor: theme.palette.background.paper,
        boxShadow: 2,
        '&:hover': { backgroundColor: theme.palette.action.hover },
      })}
      size="small"
      data-test="video-preview-close"
    >
      <CloseIcon fontSize="small" />
    </IconButton>
  );
};
